import { render, staticRenderFns } from "./EmployeesSalaries.vue?vue&type=template&id=54b066f4&"
import script from "./EmployeesSalaries.vue?vue&type=script&lang=js&"
export * from "./EmployeesSalaries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports